import { TMpkRatingState } from "./type";

export function getMpkActivityDetail(state: TMpkRatingState) {
  return state.mpkActivityDetail;
}

export function getLastTwoEventsForExecutiveDiscipline(state: TMpkRatingState) {
  return state.lastEventsForExecutiveDiscipline;
}
